<template>
<transition name="modal">
  <div class='employee-switch-modal'>
    <div class='top-border' />

    <v-flex xs10 offset-xs1 class="vf">
      <Button secondary style='float: right; position: relative; top: -7px;' @click="handleClose">Dit venster sluiten</Button>
      <div class='content fl hf mb-5'>
        <div class='golden-left'>
          <h1 class='mb-4'>Werkgever Kiezen</h1>
          <p>U kunt de context van het verzuimportaal veranderen naar een andere werkgever. U handelt dan namens de gekozen werkgever en kijkt dan als het ware door de bril van deze entiteit. U ziet de gekozen werkgever's werknemers en verzuimen zoals hij deze zelf zou zien.</p>
        </div>
        <div class='golden-right'>
        </div>
      </div>

      <div class='hf aic fl mb-5'>
        <text-field placeholder='Naar welke werkgever bent u op zoek?' class='mr-4' style='width: 64%' v-model="search">
          <v-icon slot="left">search</v-icon>
        </text-field>

        <date-picker clearable v-model="fDate" style='width: 16.5%' class='mr-4' :min="minDate" :max="maxDate"/>
        <date-picker clearable v-model="untilDate" style='width: 16.5%' :min="minDate" :max="maxDate" right/>
      </div>

      <div>
        <v-data-table
          :headers="headers"
          :items="filtersEmployers"
          :loading="isLoading"
          :search="search"
          :pagination.sync="pagination"
          :rows-per-page-items="[5, 10, 25, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }]"
          rows-per-page-text='Rijen per pagina'>
          <v-progress-linear slot='progress' color='#cdd2dc' indeterminate></v-progress-linear>
          <template slot='items' slot-scope='props'>
          <tr @click="handleSelectEmployer(props.item)"
              style='cursor: pointer;'>
              <td>{{ props.item.tradeName }}</td>
              <td>{{ props.item.customerNumber }}</td>
              <td>{{ formatDate(props.item.registrationDate) }}</td>
              <td>{{ formatDate(props.item.terminationDate) }}</td>
            </tr>
          </template>

          <div class='no-results-badge' slot='no-results'>
            <v-icon>warning</v-icon>
            <p>{{ 'errors.no-results-found' | translate }}
              <span>{{ search }}</span>.
            </p>
          </div>

          <div class="no-results-badge" slot="no-data">
            <p>{{ 'errors.no-data-found' | translate }}</p>
          </div>
        </v-data-table>
      </div>
    </v-flex>
  </div>
</transition>

</template>

<script>
import { mapGetters } from 'vuex';
import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';

import TextField from '@aevitae/aevitaeui/0_atoms/input/TextField.vue';

import Helpers from '@/shared/helpers/functions';
import Employees from '@/views/constants/employees';
import Employers from '@/resources/constants/employers';
import DatePicker from '@aevitae/aevitaeui/1_molecules/Input/DatePicker.vue';


export default {
  name: 'EmployeeSwitchModal',
  components: {
    Button,
    TextField,
    DatePicker
  },
  data () {
    return {
      headers: [
        { text: 'Naam', value: 'tradeName' },
        { text: 'Klantnummer', value: 'customerNumber' },
        { text: 'Begindatum', value: 'registrationDate' },
        { text: 'Einddatum', value: 'terminationDate' }
      ],
      search: '',
      pagination: {
        sortBy: 'tradeName',
        descending: false,
        rowsPerPage: 25
      },
      untilDate: null,
      fromDate: null
    };
  },
  computed: {
    ...mapGetters({
      employers: 'employers',
      isLoading: 'employersIsLoading'
    }),
    minDate () {
      return this.employers.map(e => e.registrationDate).sort()[0];
    },
    maxDate () {
      return new Date().toISOString().substr(0, 10);
    },
    fDate: {
      get () {
        if (this.fromDate != null) return this.fromDate;
        else return this.minDate;
      },
      set (v) {
        this.fromDate = v;
      }
    },
    filtersEmployers () {
      let result = [];
      this.employers.forEach(e => {
        if (new Date(e.registrationDate) >= new Date(this.fDate)) {
          if (e.terminationDate != null) {
            if (this.untilDate != null) {
              if (new Date(e.terminationDate) <= new Date(this.untilDate)) {
                result.push(e);
              }
            } else {
              result.push(e);
            }
          } else {
            result.push(e);
          }
        }
      });
      return result;
    }
  },
  methods: {
    handleClose () {
      this.$store.dispatch(Employees.Actions.SwitchModal.CLOSE);
    },
    handleSelectEmployer (employer) {
      this.$store.dispatch(Employers.Actions.SELECT, employer)
        .then(this.$store.dispatch(Employees.Actions.SwitchModal.CLOSE))
        .then(window.scroll(0, 0));
    },
    formatDate: (date) => Helpers.Dates.formatDate(date)
  }
};
</script>

<style lang='scss' scoped>
@import '@/assets/stylesheets/variables.scss';

.employee-switch-modal {
  position: absolute;
  z-index: 9908;

  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;

  .content {
    padding-top: 60px;
  }

  .logo {
    width: 126px;
    height: 50px;
    position: relative;
    margin-top: 30px;
    margin-right: 20px;
  }

  .top-border {
    display: block;
    height: 20px;
    background-color: $secondary;
  }
}
</style>
